var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFouryears(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 479,
    height: 484,
    viewBox: "0 0 479 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.16 111.713L303.184 16.548L298.722 137.032L416.591 111.713L335.728 201.148L442.301 257.531L322.874 274.057L462.597 468.799L266.171 321.62L229.157 436.364L192.144 321.62L90.0351 385.727L135.438 274.038L16.0107 257.512L122.584 201.129L41.7208 111.694L159.59 137.013L155.126 16.531L229.16 111.713Z",
    fill: "#FFDD00",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M313.545 13.2773H286.938V39.8842H313.545V13.2773Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M309.996 11.5034H285.163V36.3362H309.996V11.5034Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169.113 3.77393H142.506V30.3808H169.113V3.77393Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.563 2H140.73V26.8327H165.563V2Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9877 104.497H30.3809V131.104H56.9877V104.497Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4382 102.723H28.6055V127.556H53.4382V102.723Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3823 239.425H3.77539V266.032H30.3823V239.425Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8327 237.653H2V262.486H26.8327V237.653Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M102.598 370.554H75.9912V397.161H102.598V370.554Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0486 368.78H74.2158V393.613H99.0486V368.78Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M245.131 425.668H218.524V452.275H245.131V425.668Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M241.582 423.895H216.749V448.727H241.582V423.895Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M476.999 455.572H450.393V482.179H476.999V455.572Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M473.452 453.798H448.619V478.631H473.452V453.798Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M452.275 245.127H425.668V271.734H452.275V245.127Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M448.725 243.353H423.893V268.186H448.725V243.353Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M429.469 102.597H402.862V129.204H429.469V102.597Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M425.92 100.823H401.087V125.656H425.92V100.823Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.34474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M186.125 195.714L184.942 189.781L197.547 161.021L206.339 159.269L211.243 183.865L215.989 182.918L217.301 189.499L212.555 190.445L214.082 198.104L206.53 199.61L205.003 191.951L186.125 195.714ZM200.886 168.768L193.119 187.478L204.177 185.273L200.886 168.768Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M249.537 174.491L239.342 176.524L241.428 186.988L234.308 188.407L232.222 177.943L222.028 179.976L220.716 173.395L230.91 171.363L228.824 160.899L235.944 159.479L238.03 169.943L248.225 167.911L249.537 174.491Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M179.204 232.191L171.367 259.271L173.981 272.378L166.429 273.884L163.816 260.777L146.14 238.783L154.662 237.084L166.183 252.678L170.79 233.869L179.204 232.191Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M215.736 247.846C215.951 248.925 216.072 249.91 216.101 250.802L194.256 255.157C194.865 257.279 195.958 258.818 197.532 259.775C199.106 260.733 200.864 261.018 202.806 260.631C205.611 260.072 207.366 258.469 208.072 255.823L216.217 254.199C215.928 257.248 214.747 259.951 212.674 262.309C210.595 264.63 207.775 266.146 204.215 266.855C201.338 267.429 198.624 267.316 196.071 266.516C193.548 265.673 191.406 264.212 189.645 262.133C187.921 260.046 186.754 257.475 186.145 254.418C185.528 251.326 185.616 248.486 186.409 245.897C187.201 243.309 188.605 241.16 190.619 239.45C192.634 237.739 195.115 236.59 198.064 236.003C200.905 235.436 203.562 235.542 206.035 236.32C208.544 237.091 210.636 238.487 212.31 240.509C214.013 242.488 215.155 244.933 215.736 247.846ZM207.484 247.248C207.061 245.313 206.052 243.907 204.456 243.028C202.853 242.114 201.063 241.854 199.085 242.248C197.215 242.621 195.748 243.512 194.682 244.921C193.646 246.286 193.185 248.005 193.299 250.076L207.484 247.248Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M219.413 247.674C218.811 244.653 218.87 241.856 219.591 239.282C220.348 236.701 221.625 234.577 223.424 232.909C225.259 231.235 227.453 230.143 230.006 229.634C232.235 229.19 234.267 229.252 236.1 229.821C237.969 230.384 239.543 231.247 240.823 232.413L239.973 228.152L247.579 226.636L253.536 256.518L245.931 258.034L245.06 253.665C244.368 255.261 243.253 256.698 241.713 257.977C240.202 259.213 238.332 260.054 236.103 260.498C233.586 261 231.155 260.811 228.812 259.933C226.504 259.047 224.506 257.557 222.817 255.463C221.157 253.327 220.023 250.73 219.413 247.674ZM242.952 243.093C242.586 241.259 241.915 239.766 240.938 238.615C239.953 237.428 238.782 236.615 237.423 236.175C236.057 235.7 234.673 235.602 233.27 235.882C231.868 236.161 230.641 236.761 229.591 237.681C228.54 238.601 227.77 239.801 227.28 241.282C226.819 242.72 226.768 244.338 227.126 246.136C227.485 247.934 228.16 249.444 229.152 250.667C230.172 251.847 231.347 252.679 232.677 253.161C234.043 253.637 235.409 253.738 236.776 253.466C238.178 253.186 239.423 252.583 240.509 251.656C241.588 250.693 242.358 249.492 242.819 248.055C243.273 246.581 243.318 244.927 242.952 243.093Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M263.43 228.299C264.085 226.523 265.097 225.031 266.464 223.824C267.867 222.61 269.575 221.802 271.589 221.4L273.169 229.329L271.174 229.727C268.8 230.2 267.114 231.116 266.113 232.474C265.149 233.826 264.943 235.886 265.495 238.655L268.463 253.542L260.911 255.047L254.954 225.165L262.505 223.66L263.43 228.299Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M294.25 248.905C291.805 249.393 289.525 249.399 287.412 248.923C285.291 248.411 283.504 247.514 282.052 246.234C280.637 244.946 279.692 243.395 279.218 241.583L286.824 240.067C287.197 241.189 287.944 242.031 289.066 242.592C290.223 243.146 291.539 243.277 293.013 242.983C294.452 242.696 295.509 242.186 296.185 241.453C296.898 240.713 297.164 239.893 296.985 238.994C296.792 238.023 296.145 237.405 295.045 237.138C293.973 236.828 292.302 236.6 290.029 236.455C287.692 236.36 285.747 236.169 284.194 235.88C282.677 235.584 281.279 234.947 280 233.968C278.756 232.982 277.934 231.483 277.532 229.469C277.203 227.815 277.369 226.211 278.031 224.658C278.73 223.098 279.881 221.747 281.485 220.605C283.126 219.455 285.15 218.64 287.56 218.16C291.12 217.45 294.14 217.783 296.62 219.158C299.093 220.497 300.738 222.655 301.556 225.633L294.328 227.074C293.984 225.909 293.294 225.074 292.259 224.57C291.252 224.023 290.012 223.896 288.538 224.19C287.171 224.463 286.161 224.926 285.506 225.58C284.887 226.227 284.667 226.999 284.846 227.898C285.047 228.905 285.705 229.578 286.819 229.917C287.926 230.219 289.594 230.429 291.824 230.545C294.089 230.655 295.98 230.857 297.497 231.153C299.014 231.449 300.398 232.107 301.648 233.129C302.928 234.108 303.783 235.583 304.213 237.553C304.557 239.279 304.38 240.922 303.681 242.482C303.019 244.035 301.867 245.386 300.227 246.536C298.616 247.642 296.623 248.432 294.25 248.905Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M314.238 204.597L318.569 230.821L312.205 232.09L306.094 206.221L314.238 204.597ZM318.065 244.045C316.699 244.318 315.484 244.13 314.42 243.482C313.385 242.791 312.742 241.816 312.491 240.558C312.24 239.299 312.463 238.17 313.162 237.171C313.889 236.129 314.935 235.472 316.302 235.199C317.632 234.934 318.815 235.147 319.85 235.838C320.878 236.493 321.517 237.45 321.768 238.708C322.019 239.967 321.799 241.114 321.108 242.149C320.41 243.148 319.396 243.78 318.065 244.045Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFouryears);
export default __webpack_public_path__ + "static/media/fouryears.f2161b222157e21e4ac44f2aad0ac757.svg";
export { ForwardRef as ReactComponent };